var booleanParser = function (options) {
    if (options === void 0) { options = {}; }
    var _a = options.fallback, fallback = _a === void 0 ? false : _a, _b = options.strFallback, strFallback = _b === void 0 ? '' : _b;
    return {
        parse: function (data) {
            try {
                return data === undefined ? fallback : JSON.parse(data);
            }
            catch (_e) {
                return fallback;
            }
        },
        stringify: function (data) {
            return typeof data === 'boolean' ? JSON.stringify(data) : strFallback;
        },
    };
};
export default booleanParser;
//# sourceMappingURL=boolean-parser.js.map